// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PublicTemplateGrid_wrapper__F3U2T","title":"PublicTemplateGrid_title__EVs_y","templatesWrapper":"PublicTemplateGrid_templatesWrapper__8K3kH"};